import { render } from "./RequestAccessForm.vue?vue&type=template&id=1d25b076&scoped=true"
import script from "./RequestAccessForm.vue?vue&type=script&lang=js"
export * from "./RequestAccessForm.vue?vue&type=script&lang=js"

import "./RequestAccessForm.vue?vue&type=style&index=0&id=1d25b076&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d25b076"]])

export default __exports__